import { render, staticRenderFns } from "./SetLocalSKUDialog.vue?vue&type=template&id=a2e3c210"
import script from "./SetLocalSKUDialog.vue?vue&type=script&lang=js"
export * from "./SetLocalSKUDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports